module.exports = ".kan-mail-preview-dialog-container {\n  font-size: 13px;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto; }\n  .kan-mail-preview-dialog-container img {\n    max-width: 100% !important;\n    height: auto !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/mails/dialogs/mail-preview-dialog/component.scss
// module id = ./src/modules/mails/dialogs/mail-preview-dialog/component.scss
// module chunks = main